import React, {useState, useRef, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CrossIcon, DownArrowIcon} from "../../Components/Icons";
import {
    updateAdminData,
    uploadLogo,
    getAdminUserData,
} from "../../Actions/authActions";
import {executePost} from "../../Api";
import ThemeSetting from "../../Components/ThemeSetting";
import {withButtonLoader} from "../../helpers";
import classNames from "classnames";
import map from "lodash/map";
import {useNavigate} from "react-router-dom";
import "./AdminDashboard.css";
import Socket from "./../../socketHelper";
import CustomCheckbox from "../../Components/CustomCheckBox";
import {getDeviceId} from "../../utils/deviceId";
import { saveLogRocketSession } from "../../utils";

const OfficeSetting = (props) => {
    const {
        logoName,
        subdomain,
        dragOver,
        dragLeave,
        logoLoading,
        userAdmin,
        setLogoDrag,
        logoDrag,
        currentPage,
    } = props;
    useEffect(() => {
        if (!Object.keys(userAdmin).length && currentPage === "settings") {
            dispatch(getAdminUserData(subdomain));
        }
    }, [!userAdmin]);

    useEffect(() => {
        if (Socket) {
            Socket.on(`adminUpdated`, () => {
            });
        }
    }, [Socket]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let theme = {};

    const [updatedColor, setUpdatedColor] = useState({});

    const isUpdateAdminLoading = useSelector(
        (state) => state.auth.isUpdateAdminLoading
    );
    const handleColorSave = (hexColor) => {
        setUpdatedColor(hexColor);
    };

    const [themeOpts, setThemeOpts] = useState([
        {
            key: 0,
            from: "theme",
            name: "themeColor1",
            label: "Pick your main color",
            defaultValue: "",
            isOpen: false,
        },
        {
            key: 1,
            from: "theme",
            name: "themeColor2",
            label: "Pick your secondary color",
            defaultValue: "",
            isOpen: false,
        },
        {
            key: 2,
            from: "theme",
            name: "themeColor3",
            label: "Pick your accent color",
            defaultValue: "",
            isOpen: false,
        },
    ]);
    const [formData, setFormData] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    const [formCheckboxData, setFormCheckboxData] = useState({});
    const user = JSON.parse(localStorage.getItem("user"));
    const [errorMessage, setErrorMessage] = useState("");
    const [isRefreshingDevices, setIsRefreshingDevices] = useState(false);
    const [isCheckingDeviceStatus, setIsCheckingDeviceStatus] = useState(false);
    const [deviceStatusData, setDeviceStatusData] = useState(null);

    const inputLogo = useRef(null);

    useEffect(() => {
        if (!isDirty) {
            const devices = userAdmin?.paymentGateways?.devices || [];
            let defaultDeviceNickname = "";
            const association = userAdmin.cardReaderAssociation || "computer";
            const deviceId = getDeviceId();

            if (association === "computer") {
                // Computer mode: Load device for this specific computer
                const deviceCardReaders = userAdmin.deviceCardReaders || {};
                defaultDeviceNickname = deviceCardReaders[deviceId] || "";

                // If no device set for this computer, use first available
                if (!defaultDeviceNickname && devices.length > 0) {
                    defaultDeviceNickname = devices[0].deviceNickname;
                }
            } else {
                // User mode: Load global device for this user
                if (userAdmin?.selectedNmiDevice) {
                    defaultDeviceNickname = userAdmin.selectedNmiDevice;
                } else if (devices.length > 0) {
                    defaultDeviceNickname = devices[0].deviceNickname;
                }
            }

            setFormData({
                officeName: userAdmin.officeName,
                publicEmail: userAdmin.publicEmail,
                publicPhone: userAdmin.publicPhone,
                timeZone: userAdmin.timeZone,
                selectedNmiDevice: defaultDeviceNickname,
                cardReaderAssociation: association,
            });
        }
        setFormCheckboxData({
            displayStaffTab: userAdmin.displayStaffTab,
            displayPaymentMethods: userAdmin.displayPaymentMethods,
            displaySettlements: userAdmin.displaySettlements,
            messageNotification: userAdmin.messageNotification,
            transactionNotification: userAdmin.transactionNotification,
            transactionSummaryNotification: userAdmin.transactionSummaryNotification,
            settlementReportNotification: userAdmin.settlementReportNotification,
        });
    }, [userAdmin]);

    const handleChange = (e) => {
        if (e.target.type === "checkbox") {
            setFormCheckboxData({
                ...formCheckboxData,
                [e.target.name]: e.target.checked,
            });
        } else {
            setIsDirty(true);
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            });
        }
    };

    const removeLogoName = () => {
        const logoUpload = {...userAdmin};
        logoUpload.logoUrl = "";
        dispatch(updateAdminData(logoUpload));
    };

    const validateLogo = (file) => {
        const validTypes = ["image/jpeg", "image/png"];
        if (validTypes.indexOf(file.type) === -1) {
            return false;
        }
        return true;
    };

    const logofileDrop = (e) => {
        setLogoDrag(false);
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (validateLogo(file)) {
            dispatch(uploadLogo(file, user && user._id, subdomain));
        } else {
            setErrorMessage("Couldn't upload logo accept .png and .jpeg");
        }
    };

    const onUploadFileLogo = (event) => {
        const file = event.target.files[0];
        if (validateLogo(file)) {
            dispatch(uploadLogo(file, user && user._id, subdomain));
        } else {
            setErrorMessage("Couldn't upload logo accept .png and .jpeg");
        }
    };
    const onButtonUploadLogo = (e) => {
        e.preventDefault();
        inputLogo.current.click();
    };

    const handleRefreshDevices = async () => {
        try {
            setIsRefreshingDevices(true);
            const response = await executePost("SosCustomers/refreshNmiDevices", {});
            if (response && response.data) {
                // Refresh admin data to get updated devices
                dispatch(getAdminUserData(subdomain));
            }
        } catch (error) {
            console.error("Error refreshing devices:", error);
            saveLogRocketSession({ eventType: "device_refresh_error", metadata: { error: String(error) } });
        } finally {
            setIsRefreshingDevices(false);
        }
    };

    const handleCheckDeviceStatus = async () => {
        try {
            setIsCheckingDeviceStatus(true);
            setDeviceStatusData(null);
            const response = await executePost("SosCustomers/checkDeviceStatus", {});
            if (response && response.data) {
                setDeviceStatusData(response.data);
            }
        } catch (error) {
            console.error("Error checking device status:", error);
            setDeviceStatusData({error: "Failed to check device status."});
            saveLogRocketSession({ eventType: "device_status_error", metadata: { error: String(error) } });
        } finally {
            setIsCheckingDeviceStatus(false);
        }
    };

    const saveData = async () => {
        map(updatedColor, (i) => {
            theme[i.name] = i.defaultValue;
        });
        setIsDirty(true);
        setFormData(formData);
        if (formData) {
            const deviceId = getDeviceId();
            let dataToSave = {
                ...formData,
                ...formCheckboxData,
                theme,
            };

            // Handle device association
            if (formData.cardReaderAssociation === "computer") {
                // Computer mode: Save device for this specific computer
                const deviceCardReaders = userAdmin.deviceCardReaders || {};
                deviceCardReaders[deviceId] = formData.selectedNmiDevice;
                dataToSave.deviceCardReaders = deviceCardReaders;
            } else {
                // User mode: Save globally for the user
                dataToSave.selectedNmiDevice = formData.selectedNmiDevice;
            }

            await dispatch(updateAdminData(dataToSave, navigate));
            // Refetch admin data to ensure we have complete data including devices
            dispatch(getAdminUserData(subdomain));
        }
    };
    return (
        <div className="intake-content-admin">
            <div className="jumbotron p-4 p-lg-5">
                <div className="Office-content pb-3">
                    <div>
                        <div className="font-weight-bold head-font mb-4">Office Set Up</div>
                    </div>
                </div>

                <div className="d-flex justify-content-between row">
                    <div className="documents-card office-card center-message">
                        <div className="card-head-font mb-3">Office Information</div>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label
                                    htmlFor="officeName"
                                    className="office-form-label"
                                >
                                    Office Name
                                </label>

                                <input
                                    className="office-label custom-input-border-css"
                                    id="officeName"
                                    name="officeName"
                                    aria-describedby="emailHelp"
                                    placeholder="Enter Office Name"
                                    value={(formData && formData.officeName) || ""}
                                    onChange={(e) => handleChange(e)}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label
                                    htmlFor="publicPhone"
                                    className="office-form-label"
                                >
                                    Phone Number
                                </label>
                                <input
                                    className="office-label custom-input-border-css input-placeholder"
                                    id="publicPhone"
                                    name="publicPhone"
                                    aria-describedby="emailHelp"
                                    value={(formData && formData.publicPhone) || ""}
                                    placeholder="Enter Office Phone Number"
                                    onChange={(e) => handleChange(e)}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label
                                    htmlFor="publicEmail"
                                    className="office-form-label"
                                >
                                    Email Address
                                </label>
                                <input
                                    className="office-label custom-input-border-css"
                                    id="publicEmail"
                                    name="publicEmail"
                                    aria-describedby="emailHelp"
                                    value={(formData && formData.publicEmail) || ""}
                                    placeholder="Enter Office Email Address"
                                    onChange={(e) => handleChange(e)}
                                />
                            </div>
                            <div className="col-md-6 mb-3 timeZone-dropdown">
                                <label
                                    htmlFor="eventsCalTimezone"
                                    className="office-form-label"
                                >
                                    Time Zone
                                </label>
                                <select
                                    className="timezone-selector office-label officesetup-select custom-input-border-css"
                                    name="timeZone"
                                    id="eventsCalTimezone"
                                    placeholder="choose Time Zone"
                                    value={(formData && formData.timeZone) || ""}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <option value="" disabled>
                                        Choose Time Zone
                                    </option>
                                    <option value="America/New_York">(UTC-05:00) Eastern</option>
                                    <option value="America/Chicago">(UTC-06:00) Central</option>
                                    <option value="America/Denver">(UTC-07:00) Mountain</option>
                                    <option value="America/Phoenix">
                                        (UTC-07:00) Mountain - AZ
                                    </option>
                                    <option value="America/Los_Angeles">
                                        (UTC-08:00) Pacific
                                    </option>
                                    <option value="America/Anchorage">(UTC-09:00) Alaskan</option>
                                    <option value="Pacific/Honolulu">(UTC-10:00) Hawaiian</option>
                                </select>
                                <div className="timeZoneDown-arrow">
                                    <DownArrowIcon/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="documents-card office-card center-message">
                        <div className=" card-hoiz-text d-flex justify-content-between">
                            <div className="card-head-font mb-1">Logo Upload</div>
                        </div>
                        <div className="col-7 ml-2 pl-0">
                            <h5 className="card-head-logo-font">
                                {`Upload your latest logo, to replace the website's current logo.`}
                            </h5>
                        </div>
                        {logoName && userAdmin.logoUrl && (
                            <div
                                className="upload-doc-scroll mt-3"
                                style={{height: "auto", maxHeight: "300px"}}
                            >
                                <div className="logoname-display">
                                    <div>
                                        <div className="d-flex justify-content-between align-items-start">
                                            <div className="col-10 pl-0">
                                                <img
                                                    src={userAdmin.logoUrl}
                                                    className="img-fluid"
                                                    alt="Uploaded Logo"
                                                    style={{maxWidth: "100%", height: "auto"}}
                                                />
                                            </div>

                                            <div
                                                className="close-icon"
                                                onClick={(e) => removeLogoName(e)}
                                            >
                                                <CrossIcon/>
                                            </div>
                                        </div>
                                        <div className="divider"/>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div
                            className={classNames(
                                logoName ? "drag-sub-div-dash-without" : "drag-sub-div-dash"
                            )}
                        >
                            <div
                                className="card-inner-drag-drop"
                                onDrop={(a) => logofileDrop(a)}
                                onDragOver={(e) => dragOver(e, "logo")}
                                onDragLeave={(e) => dragLeave(e, "logo")}
                            >
                                <div className="dropzone dropzone-loader">
                                    <>
                                        {logoLoading ? (
                                            withButtonLoader("", logoLoading, "#000000")
                                        ) : (
                                            <>
                                                {logoDrag ? (
                                                    withButtonLoader("", logoDrag, "#6e86c4")
                                                ) : (
                                                    <>
                                                        <p className="card-drag-drop-p mb-0">
                                                            Drag and Drop file here to upload
                                                        </p>
                                                        <div className=" justify-content-center">
                                                            <input
                                                                type="file"
                                                                id="file"
                                                                name="logoUpload"
                                                                style={{display: "none"}}
                                                                onChange={(e) => onUploadFileLogo(e)}
                                                                ref={inputLogo}
                                                            />

                                                            <button
                                                                type="button"
                                                                className="sos-browse-btn p-2 sos-custom-btn-css"
                                                                onClick={(e) => onButtonUploadLogo(e)}
                                                            >
                                                                Browse Files
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                </div>
                            </div>
                            <div className="text-center">
                                <p className="max-size mb-0">Max size (3MB)</p>
                                <span className="color-text max-size">{errorMessage}</span>
                            </div>
                        </div>
                    </div>
                    <ThemeSetting
                        userAdmin={userAdmin}
                        themeOpts={themeOpts}
                        setThemeOpts={setThemeOpts}
                        handleColorSave={handleColorSave}
                    />
                    <div className="documents-card office-card center-content">
                        <div className="card-head-font mb-3">Payment Settings</div>
                        <div className="timeZone-dropdown">
                            <label
                                htmlFor="selectedNmiDevice"
                                className="card-head-logo-font"
                            >
                                Select Credit Card Reader (must click SAVE)
                            </label>
                            <select
                                className="timezone-selector office-label officesetup-select custom-input-border-css"
                                name="selectedNmiDevice"
                                id="selectedNmiDevice"
                                placeholder="Select Credit Card Reader"
                                value={(formData && formData.selectedNmiDevice) || ""}
                                onChange={(e) => handleChange(e)}
                            >
                                <option value="" disabled>
                                    Select Credit Card Reader
                                </option>
                                {map([...(userAdmin?.paymentGateways?.devices || [])].sort((a, b) =>
                                    (a.deviceNickname || '').localeCompare(b.deviceNickname || '')
                                ), (device, index) => (
                                    <option key={device.deviceNickname || index} value={device.deviceNickname}>
                                        {device.deviceNickname || `Device ${index + 1}`}
                                    </option>
                                ))}
                            </select>
                            <div className="timeZoneDown-arrow">
                                <DownArrowIcon/>
                            </div>
                        </div>

                        <div className="mt-4">
                            <label className="card-head-logo-font mb-2">
                                Associate card reader with
                            </label>
                            <div className="d-flex align-items-center" style={{gap: '20px'}}>
                                <label className="officesetup-custom-checkbox mb-0" style={{cursor: 'pointer'}}>
                                    <input
                                        type="radio"
                                        name="cardReaderAssociation"
                                        value="computer"
                                        checked={(formData.cardReaderAssociation || "computer") === "computer"}
                                        onChange={(e) => handleChange(e)}
                                        style={{marginRight: '8px', cursor: 'pointer'}}
                                    />
                                    <span>Computer</span>
                                </label>
                                <label className="officesetup-custom-checkbox mb-0" style={{cursor: 'pointer'}}>
                                    <input
                                        type="radio"
                                        name="cardReaderAssociation"
                                        value="user"
                                        checked={(formData.cardReaderAssociation || "computer") === "user"}
                                        onChange={(e) => handleChange(e)}
                                        style={{marginRight: '8px', cursor: 'pointer'}}
                                    />
                                    <span>User</span>
                                </label>
                            </div>
                        </div>

                        <div className="mt-4 d-flex justify-content-center">
                            <button
                                type="button"
                                className="sos-custom-btn sos-custom-btn-css"
                                onClick={handleRefreshDevices}
                                disabled={isRefreshingDevices}
                            >
                                {withButtonLoader("Refresh Device List", isRefreshingDevices)}
                            </button>
                        </div>

                        <div className="mt-3 d-flex justify-content-center">
                            <button
                                type="button"
                                className="sos-custom-btn sos-custom-btn-css"
                                onClick={handleCheckDeviceStatus}
                                disabled={isCheckingDeviceStatus}
                            >
                                {withButtonLoader("Check Status of Payment Terminal(s)", isCheckingDeviceStatus)}
                            </button>
                        </div>

                        {deviceStatusData && !deviceStatusData.error && (
                            <div className="mt-3" style={{
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                padding: '15px',
                                fontSize: '13px',
                            }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <strong>Device Status</strong>
                                    <span style={{fontSize: '11px', color: '#888'}}>
                                        {new Date(deviceStatusData.queryTime).toLocaleString()}
                                    </span>
                                </div>

                                <div className="mb-2" style={{
                                    display: 'flex', gap: '15px', flexWrap: 'wrap',
                                    padding: '8px', backgroundColor: '#fff', borderRadius: '6px',
                                    border: '1px solid #eee',
                                }}>
                                    <span>Total: <strong>{deviceStatusData.summary?.total || 0}</strong></span>
                                    <span style={{color: '#28a745'}}>Connected: <strong>{deviceStatusData.summary?.connected || 0}</strong></span>
                                    <span style={{color: '#dc3545'}}>Disconnected: <strong>{deviceStatusData.summary?.disconnected || 0}</strong></span>
                                </div>

                                {deviceStatusData.registeredDevices?.map((device, idx) => (
                                    <div key={device.deviceId || idx} style={{
                                        padding: '8px',
                                        backgroundColor: '#fff',
                                        borderRadius: '6px',
                                        border: '1px solid #eee',
                                        marginBottom: '6px',
                                    }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <strong>{device.deviceNickname || `Device ${idx + 1}`}</strong>
                                            <span style={{
                                                padding: '2px 8px',
                                                borderRadius: '12px',
                                                fontSize: '11px',
                                                fontWeight: 'bold',
                                                color: '#fff',
                                                backgroundColor: device.connectionStatus === 'connected' ? '#28a745' : '#dc3545',
                                            }}>
                                                {device.connectionStatus === 'connected' ? 'CONNECTED' : 'DISCONNECTED'}
                                            </span>
                                        </div>
                                        <div style={{color: '#666', fontSize: '12px', marginTop: '4px'}}>
                                            {device.make} {device.model}
                                            {device.serialNumber && <span> &middot; SN: {device.serialNumber}</span>}
                                        </div>
                                        <div style={{color: '#888', fontSize: '11px', marginTop: '2px'}}>
                                            {device.lastConnectedDate && <span>Last connected: {device.lastConnectedDate}</span>}
                                            {device.lastTransactionDate && <span> &middot; Last txn: {device.lastTransactionDate}</span>}
                                        </div>
                                    </div>
                                ))}

                                {deviceStatusData.deregisteredDevices?.length > 0 && (
                                    <div className="mt-2">
                                        <div style={{fontSize: '12px', color: '#888', marginBottom: '4px'}}>
                                            Deregistered ({deviceStatusData.deregisteredDevices.length})
                                        </div>
                                        {deviceStatusData.deregisteredDevices.map((device, idx) => (
                                            <div key={device.deviceId || idx} style={{
                                                padding: '6px 8px',
                                                backgroundColor: '#f0f0f0',
                                                borderRadius: '4px',
                                                marginBottom: '4px',
                                                fontSize: '12px',
                                                color: '#888',
                                            }}>
                                                {device.deviceNickname || device.deviceId} &middot; {device.make} {device.model}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {deviceStatusData?.error && (
                            <div className="mt-3" style={{
                                color: '#dc3545',
                                fontSize: '13px',
                                textAlign: 'center',
                            }}>
                                {deviceStatusData.error}
                            </div>
                        )}
                    </div>
                </div>

                <div className="mt-4 mb-3">
                    <div className="font-weight-bold head-font mb-3">Preferences</div>

                    <div style={{
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        padding: '20px',
                        marginBottom: '20px'
                    }}>
                        <div className="checkbox-list mb-4">
                            <div className="officeSetup-checkbox">
                                <label className="officesetup-custom-checkbox">
                                    <CustomCheckbox
                                        checked={formCheckboxData.displayStaffTab || ""}
                                        name="displayStaffTab"
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <span>Display Staff tab</span>
                                </label>
                                <label className="officesetup-custom-checkbox">
                                    <CustomCheckbox
                                        checked={formCheckboxData.displayPaymentMethods || ""}
                                        name="displayPaymentMethods"
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <span>Display Payment Methods tab</span>
                                </label>
                                <label className="officesetup-custom-checkbox">
                                    <CustomCheckbox
                                        checked={formCheckboxData.displaySettlements || ""}
                                        name="displaySettlements"
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <span>Display Settlements tab</span>
                                </label>
                            </div>
                        </div>

                        <div className="checkbox-list mb-0">
                            <div className="mb-2">
                                <label style={{fontWeight: '500'}}>Receive email notifications for:</label>
                            </div>

                            <div className="officeSetup-checkbox">
                                <label className="officesetup-custom-checkbox">
                                    <CustomCheckbox
                                        checked={formCheckboxData.messageNotification || ""}
                                        name="messageNotification"
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <span>Each message</span>
                                </label>
                                <label className="officesetup-custom-checkbox">
                                    <CustomCheckbox
                                        checked={formCheckboxData.transactionNotification || ""}
                                        name="transactionNotification"
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <span>Each transaction</span>
                                </label>
                                <label className="officesetup-custom-checkbox">
                                    <CustomCheckbox
                                        checked={formCheckboxData.transactionSummaryNotification || ""}
                                        name="transactionSummaryNotification"
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <span>Daily transaction summary</span>
                                </label>
                                <label className="officesetup-custom-checkbox">
                                    <CustomCheckbox
                                        checked={formCheckboxData.settlementReportNotification || ""}
                                        name="settlementReportNotification"
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <span>Daily settlement report</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="center-btn save-btn"
                     style={{display: 'flex', justifyContent: 'center', marginTop: '30px'}}>
                    <button
                        type="submit"
                        className="sos-custom-btn sos-custom-btn-css"
                        style={{minWidth: '300px'}}
                        onClick={() => saveData(formData)}
                        disabled={isUpdateAdminLoading}
                    >
                        {withButtonLoader("Save", isUpdateAdminLoading)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OfficeSetting;
